<template>
    <div class="tabcontent tabcontent-border-style">
        <div  class="fullInputs mb-4 pt-3">
            <div class="twoInputs">
                <div class="btnInsideInput">
                    <input type="text" autocomplete="off" id="free_search" class="form-control" v-model="search"
                           placeholder="Search"
                           @input="searchHandler" maxlength="50">
                    <button @click="searchBackEndHandler">
                        <img src="../../../assets/images/SearchIcon.png" alt="">
                    </button>
                </div>
            </div>
            <div class="oneInput">
                <select id="filter_dates" class="form-select" v-model="sort" @change="getUsers">
                    <option value="" disabled>Sort by Date</option>
                    <option value="asc" key="1">Oldest</option>
                    <option value="desc" key="2">Latest</option>
                </select>
            </div>
        </div>

            <div class="table-container" v-if="users.length > 0">
                <TableComponent model="users" name="user" :keys="keys" :thead="thead" :tbody="users"
                                updateUrl="/settings/user/edit"
                                @sort="sortUsers"
                                @update="updateHandler($event)"/>

                <div class="paginationLink">
                    <pagination :data="laravelData" @pagination-change-page="handlePagination($event)" :limit="3">
                        <template #prev-nav>
                            <span>Previous</span>
                        </template>
                        <template #next-nav>
                            <span>Next</span>
                        </template>
                    </pagination>
                </div>
            </div>
            <div v-else class="d-flex flex-column justify-content-center align-items-center gap-2 h-75 m-auto">
                <div class="h3Organization">
                    <h3 v-if="!isSearch">You Don't Have Any Users Yet</h3>
                    <h3 v-else>No Data</h3>
                </div>
                <router-link class="text-decoration-none btn-container  btn-container-no-data"
                             v-if="permissions.includes('create user') && users.length === 0 && !isSearch"
                             to="/settings/user/create">
                    <span>Create User</span>
                </router-link>
            </div>
    </div>
</template>

<script>

    import {useStore} from "vuex";
    import {ref, onMounted} from "vue";
    import TableComponent from "../../components/TableComponent";
    import repository from "../../../api-services/repository";
    import LaravelVuePagination from 'laravel-vue-pagination';

    export default {
        name: 'setting-user-page',
        components: {TableComponent, 'Pagination': LaravelVuePagination},
        setup(props, context) {
            const store = useStore();
            let users = ref([]);
            let state = ref(false);
            let originalUsers = ref([]);
            const thead = ref(['Users', 'User Email']);
            const permissions = ref([]);
            const keys = ref(['name', 'email']);
            const laravelData = ref({});
            const search = ref('');
            const isSearch = ref(false);
            const sort = ref('');

            onMounted(async () => {
                await store.dispatch('activeTap', 'settings');
                permissions.value = await store.state.auth.permissions;
                await getUsers(true);
                if(users.value.length > 0){
                    await context.emit('data-event', {'user': {action:true, search: isSearch.value}});

                }else{
                    await context.emit('data-event', {'user': {action:false, search: isSearch.value}});
                }


            });

            const searchHandler = (e) => {
                isSearch.value = true;
                // let serachedValue = e.target.value.toLowerCase();
                // let searchedData = null;
                // searchedData = originalUsers.value.filter((data) => data.name.toLowerCase().indexOf(serachedValue) >= 0 || data.email.toLowerCase().indexOf(serachedValue) >= 0);
                // users.value = searchedData;
                // if (serachedValue !== '') {
                //     isSearch.value = true;
                // } else {
                //     isSearch.value = false;
                // }
            };

            const searchBackEndHandler = async (searchFlag = true) => {
                await getUsers(searchFlag);
            };

            const filterHandler = (e) => {
                let filterType = e.target.value;
                if (filterType === 'asc') {
                    users.value.sort(function (a, b) {
                        return new Date(a.created_at) - new Date(b.created_at);
                    });
                } else {
                    users.value.sort(function (a, b) {
                        return new Date(b.created_at) - new Date(a.created_at);
                    });

                }
            };

            const handlePagination = async (pageNumber) => {
                await getUsers(pageNumber);
            };

            const getUsers = async (page = 1) => {

                try {
                    let usersData = await repository.index('users', search.value, sort.value !== '' ? sort.value : 'desc', true, page);
                    laravelData.value = usersData.data.data;

                    usersData.data.data.data.forEach((user) => {
                        user['delateFlag'] = user.entities_count === 0
                    });
                    users.value = usersData.data.data.data
                    originalUsers.value = usersData.data.data.data;
                } catch (e) {
                    if (process.env.VUE_ENV === 'development')
                        console.log({e})
                }

            };

            const sortUsers = (e) => {
                let status = !state.value;
                users.value.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                state.value = status;
            };

            const updateHandler = async (event) => {
                users.value = users.value.filter((user) => {
                    return user.id !== event
                })

                originalUsers.value = [...users.value];
                await getUsers();
            };

            return {
                thead,
                keys,
                users,
                laravelData,
                search,
                state,
                sort,
                isSearch,
                permissions,
                getUsers,
                sortUsers,
                updateHandler,
                handlePagination,
                filterHandler,
                searchHandler,
                searchBackEndHandler
            }
        }
    }
</script>
<style scoped>
</style>